// src/containers/Receptions/ReceptionList/components/ReceptionFilters.tsx
import React from "react";
import Upload2LineIcon from "remixicon-react/Upload2LineIcon";
import { CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useCommonStyles } from "$containers/CommonStyles/CommonStyles";
import { Button } from "$components";
import JCombineFilters from "$components/JCombineFilters/JCombineFilters";
import useJStyles from "$hooks/useJStyles";
import { IReceptionFiltersProps } from "../types";
import { ImportType } from "$types/import/ImportType";
import { ImportButtonWithModal } from "$components/Forms/ImportButtonWithModal";
import useAuth from "$hooks/useAuth";

const ReceptionFilters: React.FC<IReceptionFiltersProps> = ({
  filters,
  setFilter,
  selectedRowsReception,
  isExporting,
  exportReceptions,
  onAddReception,
}) => {
  const { jclasses } = useJStyles();
  const commonClasses = useCommonStyles();
  const { isClient, isContributor, isAdmin } = useAuth();

  return (
    <div className={jclasses.jBeforePaper} style={{ paddingTop: 15 }}>
      <div className={jclasses.jBeforePaper_filter}>
        <JCombineFilters
          currentCompany={filters?.company?.$eq}
          onChange={(data: any) =>
            setFilter("global", data != null ? { $eq: data } : undefined)
          }
          value={filters?.global?.$eq}
        />
        {isAdmin() && (
          <Button
            className={commonClasses.ProjectsPage__AddCta}
            variant="outlined"
            onClick={onAddReception}
          >
            <AddIcon />
            Ajouter une réception
          </Button>
        )}
        <Button
          className={commonClasses.ProjectsPage__AddCta}
          variant="outlined"
          onClick={exportReceptions}
          disabled={isExporting}
        >
          {isExporting ? (
            <CircularProgress size={16} className={commonClasses.loaderIcon} />
          ) : (
            <Upload2LineIcon />
          )}
          {`${
            selectedRowsReception?.length === 0
              ? "Exporter toutes les réceptions"
              : `Exporter des réceptions (${selectedRowsReception?.length})`
          }`}
        </Button>
        {!isClient() && !isContributor() && (
          <ImportButtonWithModal
            title="Opérations en masse"
            dataName="réceptions"
            isFeminine
            importType={ImportType.RECEPTION}
            buttonTexts={{
              importButtonText: "Importer des réceptions",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ReceptionFilters;
